import { AbacoVuexModule, State } from "@abaco/web-common/src/app";
import { Activity, FormType } from "./models/Activity";
import { RegisterType, TimesheetHeader } from "./models/RegistersModel";
import { DailyWorkerActivities, PrintableDailyActivities } from "./models/TimesheetBodyModel";

export default class TimesheetVuexModule extends AbacoVuexModule {

    @State() timesheetHeader!: TimesheetHeader | null;                  //Object containing the timesheet header information. Required for editing the timesheet
    @State() regTypes!: RegisterType[];                                 //List of all Brg type
    @State() completeBrgTypeInfo: RegisterType | undefined;             //Actual brg type

    @State({default: "TIME"}) timeSheetBrgCode!: string;                //Code of timesheet register type
    @State({default: null}) selectedTimesheet!: TimesheetHeader | null; //Selected register

    @State() filteredPrintActs!: PrintableDailyActivities[];            //Object needed to print the csv of the selected month

    @State({default: false}) canEdit!: boolean;                         //Write permissions
    @State({default: false}) canView!: boolean;                         //Read permissions
    @State({default: false}) canValidate!: boolean;                     //Validation permissions

    @State() timesheetList!: TimesheetHeader[];                         // list of all DB register

    @State() activityTypeList!: Activity[];                             //list of all activities that the user can insert into a timesheet
    @State({default: []}) activityFormTypes!: FormType[];

    @State({default: []}) cachedRows!: DailyWorkerActivities[];

    //Work days filters present in TimesheetsDetails.vue
    @State({default: null}) selectedWorkedHours!: number | null;
    @State({default: null}) compareHoursOperation!: string | null;
    @State({default: null}) selectedWorker!: Worker | null;
    @State({default: true}) isCorrectDayIncluded!: boolean;

}
